import React from 'react';
import loadable from '../../common/loadable';

const sample = require('./sample');

const AsyncDialog = loadable(() =>
  import(/* webpackChunkName: "sku-dialog" */ '../sku-dialog'),
);

export default class Price extends React.PureComponent {
  componentDidMount() {
    const { productSamplingPrice, productId, priceUnit } = this.props;
    sample.init({
      productSamplingTotalPrice: productSamplingPrice,
      productId,
      productSamplingOrderQuantity: priceUnit,
    });
  }

  render() {
    const {
      skuSampleFirstFormatPrice,
      productSamplingPrice,
      priceUnit,
      visitCountry,
      // productIsMarketGoods,
      // productIsHang,
      // productSamplingType,
      skuSample = [],
      skuAttrs,
      inventory = {},
      i18n,
      price,
      // companyId,
      productId,
    } = this.props;

    return (
      <span key="price">
        <span>{skuSampleFirstFormatPrice || productSamplingPrice}</span>/{priceUnit}
        <span className="sample-splitor"> | </span>
        <span>
          1 {priceUnit} {i18n['mainACtion_reference_mo']}
        </span>
        <span className="sample-splitor"> | </span>
        <AsyncDialog
          price={price}
          productId={productId}
          skuSample={skuSample}
          skuAttrs={skuAttrs}
          inventory={inventory}
          i18n={i18n}
          visitCountry={visitCountry}
          priceUnit={priceUnit}
          productSamplingPrice={productSamplingPrice}
        />
        {/* {productIsMarketGoods ? (
          <a
            id="J-btn-get-sample"
            className={`link-default detail-btn-get-sample-ws ${productIsHang &&
              'detail-btn-get-sample-ws-disabled'}`}
            target="_blank"
            data-spm="1002"
            onClick={e => e.preventDefault()}
            href="#"
          >
            {i18n['btnGetSample']}
          </a>
        ) : (
          <a
            data-type={productSamplingType}
            href={`//biz.alibaba.com/contract/SampleOrder.htm?data=[{%22productId%22:%22${productId}%22,%22dispatchLocation%22:%22CN%22,%22skuId%22:%22${firstSku.id ||
              ''}%22}]&tracelog=from_detail_get_sample`}
            data-domdot={`id:25853,sid:${companyId},pid:'${productId}',ext:'other=${productSamplingType}'`}
            target="_blank"
            data-spm="dsample"
            className="buy-sample__link"
          >
            <i className="item-icons ui2-icon ui2-icon-box" />
            {i18n['btnGetSample']}
          </a>
        )} */}
      </span>
    );
  }
}
